var styles = {"tend-ui-toggle-button":"tend-ui-toggle-button","tend-ui-toggle-button-selected":"tend-ui-toggle-button-selected","tend-ui-toggle-button-disabled":"tend-ui-toggle-button-disabled"};

export { styles as default };
//# sourceMappingURL=ToggleButton.module.css.js.map
